var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.id,attrs:{"id":"app"}},[_c('vue-topprogress',{ref:"topProgress",attrs:{"color":_vm.barColor,"height":_vm.barHeight}}),_c('router-view'),_c('notifications',{attrs:{"group":"plk","position":"bottom right"}}),_c('v-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }